export default "__VITE_ASSET__rT4dslhT__"